import styled from "styled-components";

export const MarkerContainer = styled.div`
    z-index: 3001;
`;